import getAPIDomain from '@purecarslabs/signal-utils/env/apiDomain'
import applyMiddleware from '@purecarslabs/signal-core/baseline/data/middleware/apply-middleware'

const postToApi = (
  segment: string,
  path: string,
  jsonData: Record<string, unknown>
) =>
  fetch(`${getAPIDomain(`/${segment}`)}/${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: jsonData ? JSON.stringify(jsonData) : undefined
  })

export default applyMiddleware()(postToApi)
